export default __webpack_public_path__ + "static/media/privacy.711540d5.pdf";